import Reports from './ReportsDefaultPage';

export default Reports;
